import React, { useState, useEffect } from "react";
import "tailwindcss/tailwind.css";
import {
  Textarea,
  Select,
  TextInput,
  SegmentedControl,
  Checkbox,
  Modal,
  Button,
  Table,
  Pagination,
  ActionIcon,
  Card,
  Title,
} from "@mantine/core";
import { Search, Send } from "tabler-icons-react";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { formatDate } from "../../utilities/utilities";
import { fetchPartyDetailApi } from "../../utilities/apis/recovery";
import AgreementListModal from "../AgreementsManager/AgreementListModal";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";

function PartyDetailPage({ formState, setFormState, errors }) {
  const [registeredNameDropDown, setRegisteredNameDropDown] = useState([]);
  const [businessUnitDropDown, setBusinessUnitDropDown] = useState([]);
  const [agreementData, setAgreementData] = useState({
    isModalOpen: false,
    list: [],
    selectedAgreement: null,
  });
  const fetchBusinessDetails = async () => {
    try {
      const { data } = await getBussinessUnit();
      if (data.success) {
        setBusinessUnitDropDown(data.result);
      } else {
        console.error("Invalid business unit response format:", response);
      }
    } catch (error) {
      console.error("Error fetching business units:", error);
    }
  };

  const fetchPartyDetail = async (name) => {
    const { data: res } = await apiWrapWithErrorWithData(
      fetchPartyDetailApi({ name }),
    );
    const names = res.map(({ registeredName: val }) => val);
    setRegisteredNameDropDown(names);
  };

  useEffect(() => {
    fetchPartyDetail();
    fetchBusinessDetails();
  }, []);
  console.log("formState: ", formState);
  return (
    <>
      {/* <Modal
        overflow="inside"
        opened={agreementData.isModalOpen}
        onClose={() =>
          setAgreementData({ ...agreementData, isModalOpen: false })
        }
        size="calc(70vw)"
        title="Agreement List"
      >
        <Table striped highlightOnHover={true} className="">
          <thead>
            <tr>
              <th>Reference no.</th>
              <th>Type</th>
              <th>Location</th>
              <th>Status</th>
              <th>Second Party</th>
              <th>Date</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {agreementData.list.map((agreement) => (
              <tr key={agreement.id}>
                <td>{agreement.id}</td>
                <td>{agreement.typeOfAgreement}</td>
                <td>{agreement.location}</td>
                <td>{agreement.status}</td>
                <td>{agreement.secondParty.name}</td>
                <td>{formatDate(agreement.createdAt)}</td>
                <td>
                  <ActionIcon
                    title="Select Agreement"
                    onClick={() => handleAgreementSelect(agreement)}
                  >
                    <Send color="green" />
                  </ActionIcon>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </Modal> */}
      <AgreementListModal
        agreementData={agreementData}
        setAgreementData={setAgreementData}
        setFormState={setFormState}
        setRegisteredNameDropDown={setRegisteredNameDropDown}
      />
      <div className="dashboard-header">
        <div>
          <h1 className="dashboard-heading">Add New Receivable</h1>
          <p className="dashboard-subtitle">
            Create a new recovery for a contract
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-5">
        <Card shadow="sm" radius="md" withBorder p="lg" className="mb-5">
          <Checkbox
            size="md"
            radius="md"
            color="#2196F3"
            label="This recovery is linked to an existing contract"
            checked={formState.isExistingAgreement}
            onChange={() =>
              setFormState((prevState) => ({
                ...prevState,
                isExistingAgreement: !prevState.isExistingAgreement,
              }))
            }
          />
          {formState.isExistingAgreement === true && (
            <div className="flex" style={{ marginTop: "20px" }}>
              <TextInput
                radius="md"
                size="md"
                label="Connected Contract"
                placeholder="Enter Contract Number"
                type="number"
                readOnly
                value={
                  agreementData.selectedAgreement != null
                    ? agreementData.selectedAgreement
                    : ""
                }
                onChange={(event) => {
                  // const value = event.currentTarget.value;
                  // const commaSeparatedValues = value.split(",").map((v) => v.trim());
                  // form.setFieldValue(
                  //   "relationshipWith",
                  //   event.currentTarget.value
                  // );
                }}
                style={{
                  width: "88%",
                  display: "inline-block",
                  marginRight: "2%",
                }}
              />
              <Button
                size="md"
                radius="md"
                className="max-w-lg"
                color="#2196F3"
                onClick={() =>
                  setAgreementData({ ...agreementData, isModalOpen: true })
                }
                style={{
                  width: "10%",
                  display: "inline-block",
                  marginBottom: "0",
                  marginTop: "auto",
                  padding: "0",
                }}
              >
                <Search size={20} strokeWidth={3} />
              </Button>
            </div>
          )}
        </Card>
        <Card shadow="sm" radius="md" withBorder p="lg" className="mb-5">
          <Select
            radius="md"
            size="md"
            required
            label="Business Unit"
            placeholder="Select Business Unit"
            value={formState.businessUnit || ""}
            data={businessUnitDropDown.map((unit) => ({
              value: unit.id + "",
              label: unit.name,
            }))}
            onChange={(value) =>
              setFormState((prevState) => ({
                ...prevState,
                businessUnit: value,
              }))
            }
            error={errors.businessUnit}
          />
          <TextInput
            radius="md"
            size="md"
            label="Business Point of Contact"
            placeholder="Enter Business Point of Contact"
            value={formState.businessPOC != null ? formState.businessPOC : ""}
            onChange={(event) => {
              const newValue = event.currentTarget.value;
              setFormState((prevState) => ({
                ...prevState,
                businessPOC: newValue,
              }));
            }}
          />
        </Card>
      </div>

      <div className="flex flex-col">
        <Card shadow="sm" radius="md" withBorder p="lg" className="mb-5">
          <div className="flex justify-between items-center mb-5">
            <Title order={4}>Debtor Details</Title>
            <SegmentedControl
              color="primary"
              data={["entity", "Individual"]}
              value={formState.type || "entity"}
              onChange={(value) =>
                setFormState((prevState) => ({
                  ...prevState,
                  type: value,
                }))
              }
            />
          </div>

          <div className="grid grid-cols-3 gap-4">
            {formState.type === "entity" && (
              <>
                <Select
                  radius="md"
                  size="md"
                  required
                  className="inputCustom w-full ml-0 leading-[1.55]"
                  label="Entity Type"
                  placeholder="Select Entity Type"
                  value={formState.entityType || ""}
                  data={[
                    { value: "Company", label: "Company" },
                    { value: "LLP", label: "LLP" },
                    { value: "Partnership Firm", label: "Partnership Firm" },
                    { value: "Sole Proprietary", label: "Sole Proprietary" },
                  ]}
                  onChange={(value) =>
                    setFormState((prevState) => ({
                      ...prevState,
                      entityType: value,
                    }))
                  }
                  error={errors.entityType}
                />
                <Select
                  radius="md"
                  size="md"
                  required
                  searchable
                  creatable
                  className="inputCustom w-full ml-0 m-0 p-0 leading-[1.55]"
                  label="Registered Name"
                  placeholder="Enter Registered Name"
                  value={
                    formState.registeredName != null
                      ? formState.registeredName
                      : ""
                  }
                  getCreateLabel={(value) => `+ add ${value}`}
                  data={[...registeredNameDropDown]}
                  onCreate={(value) => {
                    setFormState((prevState) => ({
                      ...prevState,
                      registeredName: value,
                    }));
                    setRegisteredNameDropDown([
                      ...registeredNameDropDown,
                      value,
                    ]);
                  }}
                  onChange={(value) =>
                    setFormState((prevState) => ({
                      ...prevState,
                      registeredName: value,
                    }))
                  }
                  error={errors.registeredName}
                />
                <TextInput
                  radius="md"
                  size="md"
                  required
                  label="Authorised Representative Name"
                  placeholder="Enter Authorised Representative Name"
                  value={
                    formState.representativeName != null
                      ? formState.representativeName
                      : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      representativeName: newValue,
                    }));
                  }}
                  error={errors.representativeName}
                />
                <TextInput
                  radius="md"
                  size="md"
                  required
                  label="Authorised Representative Email Address"
                  placeholder="Enter Authorised Representative Email Address"
                  value={
                    formState.representativeEmail != null
                      ? formState.representativeEmail
                      : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      representativeEmail: newValue,
                    }));
                  }}
                  error={errors.representativeEmail}
                />
                {/* <Select
                required
                label="Business Unit"
                placeholder="Select Business Unit"
                value={formState.businessUnit}
                data={businessUnitDropDown.map((unit) => ({
                  value: unit.id,
                  label: unit.name,
                }))}
                onChange={(value) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    businessUnit: value,
                  }))
                }
                error={errors.businessUnit}
              />
              <TextInput
                label="Business POC"
                placeholder="Enter Business POC"
                value={formState.businessPOC}
                onChange={(event) => {
                  const newValue = event.currentTarget.value;
                  setFormState((prevState) => ({
                    ...prevState,
                    businessPOC: newValue,
                  }));
                }}
              /> */}
                <Textarea
                  radius="md"
                  minRows={3}
                  autosize
                  label="Registered Address"
                  placeholder="Enter Registered Address"
                  value={
                    formState.registeredAddress != null
                      ? formState.registeredAddress
                      : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      registeredAddress: newValue,
                    }));
                  }}
                />
                <Textarea
                  radius="md"
                  minRows={3}
                  autosize
                  label="Corporate Address"
                  placeholder="Enter Corporate Address"
                  value={
                    formState.corporateAddress != null
                      ? formState.corporateAddress
                      : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      corporateAddress: newValue,
                    }));
                  }}
                />
              </>
            )}
            {formState.type === "individual" && (
              <>
                <TextInput
                  radius="md"
                  size="md"
                  required
                  label="Individual Name"
                  placeholder="Enter Individual Name"
                  value={
                    formState.individualName != null
                      ? formState.individualName
                      : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      individualName: newValue,
                    }));
                  }}
                  error={errors.individualName}
                />
                <TextInput
                  radius="md"
                  size="md"
                  required
                  label="Email Address"
                  placeholder="Enter Email Address"
                  value={formState.emailID != null ? formState.emailID : ""}
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      emailID: newValue,
                    }));
                  }}
                  error={errors.emailID}
                />
                <TextInput
                  radius="md"
                  size="md"
                  label="Father's Name"
                  placeholder="Enter Father's Name"
                  value={
                    formState.fathersName != null ? formState.fathersName : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      fathersName: newValue,
                    }));
                  }}
                />
                <Textarea
                  radius="md"
                  size="md"
                  label="Residence Address"
                  placeholder="Enter Residence Address"
                  value={
                    formState.residenceAddress != null
                      ? formState.residenceAddress
                      : ""
                  }
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      residenceAddress: newValue,
                    }));
                  }}
                />
                <TextInput
                  radius="md"
                  size="md"
                  label="PAN Number"
                  placeholder="Enter PAN Number"
                  value={formState.panNo != null ? formState.panNo : ""}
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      panNo: newValue,
                    }));
                  }}
                />
                <TextInput
                  radius="md"
                  size="md"
                  label="Phone Number"
                  type="number"
                  placeholder="Enter Phone Number"
                  value={formState.phoneNo != null ? formState.phoneNo : ""}
                  onChange={(event) => {
                    const newValue = event.currentTarget.value;
                    setFormState((prevState) => ({
                      ...prevState,
                      phoneNo: newValue,
                    }));
                  }}
                />
              </>
            )}
          </div>
        </Card>
      </div>
    </>
  );
}

export default PartyDetailPage;
